export const AMENITY = '/amenities';
export const CITY = '/city';
export const CUISINE = '/cuisine';
export const CURATOR = '/curator';
export const EATERY = '/eatery';
export const FILE = '/file';
export const TAG = '/tag';

//Anit
export const PICKS = '/picks';
export const CONTRIBUTOR = '/topContributors';
export const TOPPICKS = '/featured/picks';
export const LOCALEATERY = '/eatery/city';
export const STORY = '/story';
